module.exports = __webpack_public_path__ + "img/dashboard_document.9ef9408f.svg";